export default {
	sec_10: {
		title: {
			one: '은행과 같은',
			two: '환전',
		},
		desc: {
			one: '판매 하고 구매 하고',
			two: '아직도 이쪽 저쪽 다니면서 환전 하시나요?',
		},
		btn: {
			one: '회원가입하기',
			two: '앱 다운로드',
		},
	},
	sec_04: {
		title: {
			one: '환전 하고',
			two: '바로 송금',
		},
		desc: {
			one: '아직도 암호 자산 구입하고 보내기가 힘드신가요?',
			two: '은행처럼 사용하세요. 바로 송금 및 출금이 가능합니다.',
		},
		cards: {
			one: {
				title: {
					one: '버튼 한 번으로',
					two: '쉽게 환전하세요.',
				},
				description: {
					one: '자동 환율, 자동 판매',
					two: '너무 쉬운 인터페이스',
				},
			},
			two: {
				title: {
					one: '원하는 자산과 언제든지',
				},
				description: {
					one: '암호 자산과 암호 자산 간의 환전도 가능',
					two: '암호 자산을 JPYS 포인트로',
					three: '환전도 가능',
				},
			},
		},
	},
};
